import { safeToString } from '@vue-storefront/core/helpers/primitives'

export default {
  props: {
    variant: {
      type: Object,
      default: () => ({})
    },
    selectedFilters: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    isActive () {
      const selectedVariantFilter = this.selectedFilters[this.variant.type]
      if (!selectedVariantFilter) return false
      if (Array.isArray(selectedVariantFilter)) return !!selectedVariantFilter.find(variant => variant.id === this.variant.id)
      return safeToString(selectedVariantFilter.id) === safeToString(this.variant.id)
    }
  }
}
